import type { GencowProcedureDef } from "@gencow/core";
import { ragCorporaProcedures } from "../../rag-corpora-runtime.js";
import { ragIngestProcedures } from "../../rag-ingest-runtime.js";
import { ragOperationsProcedures } from "../../rag-operations-runtime.js";

export const ragBuiltinProcedures = {
  ...ragIngestProcedures,
  ...ragCorporaProcedures,
  ...ragOperationsProcedures,
} as const;

export function collectRagBuiltinProcedureMaps(): {
  queryProcedureMap: Map<string, GencowProcedureDef<"query", any, any, any>>;
  mutationProcedureMap: Map<string, GencowProcedureDef<"mutation", any, any, any>>;
} {
  const queryProcedureMap = new Map<string, GencowProcedureDef<"query", any, any, any>>();
  const mutationProcedureMap = new Map<string, GencowProcedureDef<"mutation", any, any, any>>();

  for (const proc of Object.values(ragBuiltinProcedures)) {
    if (proc.kind === "query") {
      queryProcedureMap.set(proc.name, proc as GencowProcedureDef<"query", any, any, any>);
    } else {
      mutationProcedureMap.set(proc.name, proc as GencowProcedureDef<"mutation", any, any, any>);
    }
  }

  return { queryProcedureMap, mutationProcedureMap };
}
